import {
  FactsApi,
  FactTypeResponse,
  CreateFactTypeRequest,
  UpdateFactTypeRequest,
  FactTypeListResponse
} from 'we-tree-api-client/v2';

import { getApiConfiguration } from '@/services/SessionService';
import { ApiResult, withApiSetup } from './apiWrapper';

/**
 * Wrapped fact types API with standardized error handling
 */
class WrappedFactTypesApi {
  /**
   * List all fact types
   */
  async listFactTypes(isActive?: boolean): Promise<ApiResult<FactTypeListResponse>> {
    return withApiSetup(
      (config) => new FactsApi(config),
      getApiConfiguration,
      (api) => api.listFactTypes(isActive)
    );
  }

  /**
   * Get a fact type by ID
   */
  async getFactType(factTypeId: string): Promise<ApiResult<FactTypeResponse>> {
    return withApiSetup(
      (config) => new FactsApi(config),
      getApiConfiguration,
      (api) => api.getFactType(factTypeId)
    );
  }

  /**
   * Get a fact type by slug
   */
  async getFactTypeBySlug(slug: string): Promise<ApiResult<FactTypeResponse>> {
    return withApiSetup(
      (config) => new FactsApi(config),
      getApiConfiguration,
      (api) => api.getFactTypeBySlug(slug)
    );
  }

  /**
   * Create a new fact type
   */
  async createFactType(factTypeData: CreateFactTypeRequest): Promise<ApiResult<FactTypeResponse>> {
    return withApiSetup(
      (config) => new FactsApi(config),
      getApiConfiguration,
      (api) => api.createFactType(factTypeData)
    );
  }

  /**
   * Update an existing fact type
   */
  async updateFactType(factTypeId: string, factTypeData: UpdateFactTypeRequest): Promise<ApiResult<FactTypeResponse>> {
    return withApiSetup(
      (config) => new FactsApi(config),
      getApiConfiguration,
      (api) => api.updateFactType(factTypeId, factTypeData)
    );
  }

  /**
   * Delete a fact type
   */
  async deleteFactType(factTypeId: string): Promise<ApiResult<void>> {
    return withApiSetup(
      (config) => new FactsApi(config),
      getApiConfiguration,
      (api) => api.deleteFactType(factTypeId)
    );
  }
}

/**
 * Wrapped fact types API instance with standardized error handling
 */
export const factTypesApi = new WrappedFactTypesApi();

export default factTypesApi;
